/**
 * Skip-Link (.skipLink, frontend_*.php): Der Core faengt alle a[href^="#"] ab
 * (preventDefault + eigenes Scrollen mit Sticky-Navi-Offset) - dabei wandert der
 * Tastatur-Fokus nicht mit. Hier wird er zusaetzlich ins Ziel (#mainContent,
 * tabindex="-1") gesetzt; das Scrollen uebernimmt weiter der Core.
 */
document.addEventListener('DOMContentLoaded', () => {
    const skipLink = document.querySelector('.skipLink');
    if (!skipLink) return;

    skipLink.addEventListener('click', () => {
        const target = document.getElementById(skipLink.getAttribute('href').slice(1));
        target?.focus({ preventScroll: true });
    });
});
